import "./speedselect.scss";
import Text from "../Text/Text";

function SpeedSelect(
  { src , text } 
) {
  return (
    <div className="SpeedBox">
      <img src={src} alt="" />
      <Text FontWight="Bold">{text}</Text>
    </div>
  );
}
export default SpeedSelect;
